import { render, staticRenderFns } from "./PrintDocumentNew.vue?vue&type=template&id=2894d66b&"
import script from "./PrintDocumentNew.vue?vue&type=script&lang=js&"
export * from "./PrintDocumentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports